module.exports = ".footer {\n  min-height: 80px;\n}\n@media (max-width: 1300px) {\n  .footer {\n    padding-left: 60px;\n    overflow: hidden;\n  }\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app/footer/footer.component.less
// module id = ./src/app/app/footer/footer.component.less
// module chunks = main